import { Box, CircularCloseIcon, Columns, Stack, t } from '@ui';

import * as css from './WelcomeBanner.css';

type WelcomeBannerProps = {
    onClose: () => void;
};

export const WelcomeBanner = ({ onClose }: WelcomeBannerProps) => {
    return (
        <Box className={css.container}>
            <img src="golf.webp" alt="a man and a woman talking about the elva system" className={css.bannerImage} />
            <Box mb={{ sm: 32, md: 64 }} paddingBlock={{ sm: 32, md: 64 }} paddingInline={{ sm: 24, md: 48 }}>
                <Box mb={24}>
                    <hgroup>
                        <Stack gap={8}>
                            <h2 className={t({ variant: 'h2', color: 'light' })}>Welcome to the ELVA System</h2>
                            <p className={t({ variant: 'pLarge', color: 'light' })}>
                                The State of the Art Golf Swing Analysis System
                            </p>
                        </Stack>
                    </hgroup>
                </Box>
                <button className={css.close} onClick={onClose}>
                    <CircularCloseIcon color={'white'} />
                </button>
                <section>
                    <Columns cols={{ sm: 1, md: 2, lg: 3 }} gap={{ sm: 16, md: 32, lg: 48 }}>
                        <Stack gap={8}>
                            <h3 className={t({ variant: 'h3', color: 'success' })}>Review your swings</h3>
                            <p className={t({ variant: 'p', color: 'light' })}>
                                Align your feelings with reality by measuring key swing dynamics—sway, thrust, lift,
                                bend, tilt, and rotation.
                            </p>
                        </Stack>
                        <Stack gap={8}>
                            <h3 className={t({ variant: 'h3', color: 'success' })}>Compare swings</h3>
                            <p className={t({ variant: 'p', color: 'light' })}>
                                Compare your last training to your favorite swings, or to swings from professional
                                golfers, to see where the main differences are.
                            </p>
                        </Stack>
                        <Stack gap={8}>
                            <h3 className={t({ variant: 'h3', color: 'success' })}>3D analysis</h3>
                            <p className={t({ variant: 'p', color: 'light' })}>
                                Analyze your swing using the ELVA 3D to understand your movements better.
                            </p>
                        </Stack>
                    </Columns>
                </section>
            </Box>
        </Box>
    );
};
